var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnknownFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 6,
    fill: "#DF6438"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.487 10.7738L21.1555 6.67589C20.6948 6.24002 20.0918 6 19.4576 6H11.2109C9.84859 6 8.74023 7.10836 8.74023 8.4707V26.5293C8.74023 27.8916 9.84859 29 11.2109 29H23.7891C25.1514 29 26.2598 27.8916 26.2598 26.5293V12.5686C26.2598 11.8925 25.9781 11.2383 25.487 10.7738ZM24.1781 11.3906H20.8242C20.7004 11.3906 20.5996 11.2899 20.5996 11.166V8.00513L24.1781 11.3906ZM23.7891 27.6523H11.2109C10.5917 27.6523 10.0879 27.1485 10.0879 26.5293V8.4707C10.0879 7.85146 10.5917 7.34766 11.2109 7.34766H19.252V11.166C19.252 12.033 19.9573 12.7383 20.8242 12.7383H24.9121V26.5293C24.9121 27.1485 24.4083 27.6523 23.7891 27.6523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3066 14.9844H12.4238C12.0517 14.9844 11.75 15.2861 11.75 15.6582C11.75 16.0303 12.0517 16.332 12.4238 16.332H22.3066C22.6788 16.332 22.9805 16.0303 22.9805 15.6582C22.9805 15.2861 22.6788 14.9844 22.3066 14.9844Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3066 18.5781H12.4238C12.0517 18.5781 11.75 18.8798 11.75 19.252C11.75 19.6241 12.0517 19.9258 12.4238 19.9258H22.3066C22.6788 19.9258 22.9805 19.6241 22.9805 19.252C22.9805 18.8798 22.6788 18.5781 22.3066 18.5781Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6905 22.1719H12.4238C12.0517 22.1719 11.75 22.4736 11.75 22.8457C11.75 23.2178 12.0517 23.5195 12.4238 23.5195H15.6905C16.0627 23.5195 16.3644 23.2178 16.3644 22.8457C16.3644 22.4736 16.0627 22.1719 15.6905 22.1719Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknownFile);
export default __webpack_public_path__ + "static/media/unknown-file.b5fa98d2eb1c8d9aadd28f1c960f492d.svg";
export { ForwardRef as ReactComponent };